import DownloadPdfComponent from "../DownloadPdfComponent/DownloadPdfComponent";
import "./AlertModal.scss";
import PropTypes from "prop-types";
import imgNotAvailible from '../../assests/img_not_availible.png';
import globals from "../../config/appconfig";
import { useEffect, useState } from "react";

/**
 * @function AlertModal Modal components
 * @param idModale id type of the Modal Component
 * @returns {JSX.Element}
*/
const AlertModal = ({ idModale, title, description }) => {
    const [openModal, setOpenModal] = useState(false);
    const showAlert  = localStorage.getItem('showAlert'); 

    useEffect(() => {
        if(showAlert === null) {
            setOpenModal(true)
        } 
    }, []);

    const setOpenModalF = () => {
        localStorage.setItem('showAlert', false);
        setOpenModal(false)
    }

    return (
        <>
            {
                openModal ? (
                    <div className="ModalContainer">
                        <div className={`${(openModal) ? "modal-backdrop fade show" : ""}`}></div>
                        <div className={`${(openModal) ? "modal fade show" : ""}`} tabIndex="-1" role="document" id={idModale}>
                            <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header row">
                                        <div className="col-12 col-lg-8 modal__title">
                                            <span className="modal-title" id="exampleModalTitle" role="contentinfo" tabIndex="0" aria-label={title}>{title}</span>
                                        </div>
                                        <div className="modal__button--close" onClick={() => { setOpenModalF() }}>
                                            <span className="material-icons-outlined" style={{ fontSize: "24px" }} type="button" tabIndex="0" aria-label={"close"}>close</span>
                                        </div>
                                    </div>
                                    <div className="modal-body text-center pb-4" role="contentinfo" tabIndex="0">
                                        <div>
                                            <span className="material-icons-outlined" style={{ fontSize: "72px", color: "#2B5A95" }} type="button" tabIndex="0" aria-label={"info"}>info</span></div>
                                        <div>{description}</div>
                                    </div>
                                    <div class="modal-footer text-center">
                                        <button class="btn btn-primary" type="button" onClick={() => { setOpenModalF() }}>Ok</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }
        </>
    );
};

AlertModal.propTypes = {
    idModale: PropTypes.string.isRequired,
    title: PropTypes.string,
    description: PropTypes.string
};

AlertModal.defaultProps = {
    idModale: "",
    title: "ATTENZIONE",
    description: "Sito con funzioni in aggiornamento."
};

export default AlertModal;